<template>

<div v-if='isLoading' class="loader text-center">
    <img src='/resources/loader.svg' width="100px">
</div>

</template>

<script>
    export default {

        mounted() {
            var me = this;

            bus.$on('loader', ( state ) => {

                me.isLoading = state;

            })
        },

        created() {

        },

        data() {

            return {
                isLoading : false
            }

        },

        methods : {
           
        }

    }
</script>

<style lang='less'>
   .loader {
        position: fixed;
        z-index: 99999;
        background-color: rgba(255,255,255,0.6);
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 0;
        left: 0;

        img{
            max-width: 100%;
        }
   } 
</style>